module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(_vm.vehicles && _vm.vehicles.length) ? _c('div', _vm._l((_vm.vehicles), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "vehicle",
      on: {
        "click": function($event) {
          return _vm.$emit('onVehicleClick', item)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [(item.imageUrl) ? _c('app-image', {
      staticClass: "image",
      attrs: {
        "imageUrl": item.imageUrl,
        "alt": 'vehicle image'
      }
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "like-btn",
      attrs: {
        "disabled": _vm.disableFavorite
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit('toggleFavorite', item)
        }
      }
    }, [_c('span', {
      staticClass: "dbc-icon dbc-icon-heart"
    })])], 1), _vm._v(" "), _c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.year) + " " + _vm._s(item.make) + " " + _vm._s(item.model) + " " + _vm._s(item.submodel))]), _vm._v(" "), _c('span', {
      staticClass: "price"
    }, [_vm._v(_vm._s(_vm.price(item.offeringPrice)))])])
  }), 0) : _c('no-vehicles', {
    attrs: {
      "vehiclesCategory": 'favorites'
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d5ff8d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d5ff8d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/garage/garage-favorites-list.vue
// module id = 816
// module chunks = 0